const state = {
  locale: localStorage.getItem('locale') || 'zh-TW', // 默认简体中文
  supportedLocales: ['zh-CN', 'zh-TW', 'en'] // 支持的语言列表
}

const mutations = {
  SET_LOCALE (state, locale) {
    state.locale = locale
    localStorage.setItem('locale', locale) // 持久化存储
  }
}

const actions = {
  switchLocale ({ commit }, locale) {
    commit('SET_LOCALE', locale)
  }
}

const getters = {
  currentLocale: (state) => state.locale,
  isZh: (state) => state.locale.startsWith('zh-')
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/language.js